import { Layout } from "@/components";
import { Navigate } from "react-router-dom";
import {
  DownloadProfile,
  MyNeighbors,
  OwnerBillingHistory,
  OwnerCommunities,
  OwnerHelpDocument,
  OwnerMyProfile,
  OwnerTransactionHistory,
  TermsCondition,
} from "@/pages";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { ROLE_OWNER } from "@/lib/utils";
import { routes } from "../utils";
import ProtectedRoute from "../ProtectedRoute";
import { Role, routerRoles } from "../Router";
import { DashboardRoutes } from "./DashboardRoutes";
import { FinanceRoutes } from "./FinanceRoutes";
import { IncidentMgmtRoutes } from "./IncidentMgmtRoutes";
import { MasterDataRoutes } from "./MasterDataRoutes";
import OwnerProtectedRoute from "./OwnerProtectRoute";
import BomProtectedRoute from "./BomProtectRoute";

const OwnerBomRoutes = () => {
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const isOwner = currentRole == ROLE_OWNER;

  return [
    {
      // only for owners
      path: routes.owner,
      element: <ProtectedRoute allowedRoles={[routerRoles.owner as Role]} />,
      children: [
        {
          path: routes.termsCondition,
          element:
            isOwner ? (
              <TermsCondition />
            ) : (
              <Navigate to={`/${routes.owner}/${routes.dashboard}`} />
            ),
        },
        {
          path: routes.downloadFile,
          element:
            isOwner ? (
              <DownloadProfile />
            ) : (
              <Navigate to={`/${routes.owner}/${routes.dashboard}`} />
            ),
        },
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: <Navigate to={`/${routes.owner}/${routes.dashboard}`} />,
            },
            DashboardRoutes(),
            {
              path: routes.billingHistory,
              element: <OwnerBillingHistory />,
            },
            {
              path: routes.transactionHistory,
              element: <OwnerProtectedRoute />,
              children: [{ path: "", element: <OwnerTransactionHistory /> }],
            },
            {
              path: routes.communities,
              element: <OwnerCommunities />,
            },
            {
              path: routes.myProfile,
              element: <OwnerProtectedRoute />,
              children: [
                {
                  path: "",
                  element: <OwnerMyProfile />,
                },
              ],
            },
            {
              path: routes.myNeighbors,
              element: <MyNeighbors />,
            },
            IncidentMgmtRoutes(),
            {
              path: routes.helpDocument,
              element: <OwnerHelpDocument />,
            },
          ],
        },
      ],
    },
    {
      path: routes.bom,
      element: (
        <ProtectedRoute
          allowedRoles={[routerRoles.owner as Role, routerRoles.bom as Role]}
        />
      ),
      children: [
        {
          path: "",
          element: <BomProtectedRoute />,
          children: [
            {
              path: "",
              element: <Layout />,
              children: [
                {
                  path: "",
                  element: (
                    <Navigate
                      to={`/${routes.bom}/${routes.dashboard}`}
                      replace
                    />
                  ),
                },
                DashboardRoutes(),
                {
                  path: routes.communities,
                  element: <OwnerCommunities />,
                },
                IncidentMgmtRoutes(),
                {
                  path: routes.helpDocument,
                  element: <OwnerHelpDocument />,
                },
                FinanceRoutes(),
                MasterDataRoutes(),
              ],
            },
          ],
        },
      ],
    },
  ];
};

export default OwnerBomRoutes;
